import { Box, Tooltip } from '@mantine/core';
import { IconLock, IconLockOpen } from '@tabler/icons-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setRequestedActionToUnlock, setSuggestSubscriptionModal } from '../../store/subscriptionSlice';

const UnlockFeatureButton = ({ size, restrictionKey }) => {
  const [hoverLock, setHoverLock] = useState(false);
  const dispatch = useDispatch();

  const handleLockClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(setSuggestSubscriptionModal(true));
    dispatch(setRequestedActionToUnlock(restrictionKey));
  };

  const iconSize = size === 'lg' ? 20 : size === 'sm' ? 12 : 16;

  return (
    <Box
      ml="sm"
      component="span"
      visibleFrom="md"
      onMouseEnter={() => setHoverLock(true)}
      onMouseLeave={() => setHoverLock(false)}
      onClick={handleLockClick}
      style={{ float: 'right', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', pointerEvents: 'auto' }}
    >
      <Tooltip label="Unlock feature." position="top">
        {hoverLock ? <IconLockOpen size={iconSize} /> : <IconLock size={iconSize} />}
      </Tooltip>
    </Box>
  );
};

export default UnlockFeatureButton;
